<template>
  <Grid gaf="column" justify-content="space-between" align-items="start">
    <Grid gap="var(--r-space-sm)" class="text-secondary-3">
      <div class="text-heading-3">Recommendations table</div>
      <div class="text-body-1">Determine the likelihood of renewing subscriptions</div>
    </Grid>

    <Grid gap="var(--r-space-md)" justify-items="end" class="text-right">
      <Grid gap="var(--r-space-md)" class="actions">
        <div class="text-secondary-5 text-body-1">
          Set recommendations for
          <span class="text-heading-3">{{ numberOfSelectedRows }}</span>
          selected subscriptions:
        </div>
        <Grid gaf="column" gap="var(--r-space-sm)" class="buttons">
          <SpecialBtn
            v-for="status of statuses"
            :key="status.id"
            v-bind="specialButtonState"
            :type="status.name.replace('to cancel', 'for cancel')"
            :style="{ '--width': btnWidth(status.name) }"
            @click="$emit('open-dialog', { status: { ...status }, numberOfSelectedRows })"
          >
            {{ status.name.toUpperCase() }}
          </SpecialBtn>
        </Grid>
      </Grid>
      <ShowHideCols :ag-grid="agGrid" />
    </Grid>
  </Grid>
</template>

<script>
// Libraries
import { mapState } from 'vuex'
// Components
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import SpecialBtn from '@/ui/SpecialBtn'

export default {
  components: {
    ShowHideCols,
    SpecialBtn
  },

  props: {
    agGrid: { required: true }
  },

  computed: {
    ...mapState('recommendations', ['selectAll', 'rowsSelected', 'totalRows', 'statuses']),

    numberOfSelectedRows() {
      if (this.selectAll) {
        return this.totalRows - this.rowsSelected.length
      }
      return this.rowsSelected.length
    },

    specialButtonState() {
      const state = { disable: false, active: false }

      if (!this.numberOfSelectedRows) state.disable = true
      else state.active = true

      return state
    },

    btnWidth() {
      return btnType => {
        const map = {
          certain: '72px',
          likely: '66px',
          unknown: '66px',
          'not-likely': '76px',
          'to cancel': '82px'
        }

        return map[btnType]
      }
    }
  }
}
</script>
